import { OTHER, ZOCDOC } from '../GoogleMap/mapStylers';

let zdQueryParams = '';

ZOCDOC.forEach(style => {
    zdQueryParams += `&style=feature:${style.featureType}%7Celement:${style.elementType}`;

    style.stylers.forEach(styler => {
        const styleName = Object.keys(styler);
        const styleValue = styler[styleName].replace('#', '0x');
        zdQueryParams += `%7C${styleName}:${styleValue}`;
    });
});

let unthemedQueryParams = '';

OTHER.forEach(style => {
    unthemedQueryParams += `&style=feature:${style.featureType}%7Celement:${style.elementType}`;

    style.stylers.forEach(styler => {
        const styleName = Object.keys(styler);
        const styleValue = styler[styleName].replace('#', '0x');
        unthemedQueryParams += `%7C${styleName}:${styleValue}`;
    });
});

export const getThemedQueryParams = () => zdQueryParams;
export const getUnthemedQueryParams = () => unthemedQueryParams;
